import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { parse } from "qs";

import SubscriptionHeader from "../SubscriptionHeader";
import SubscriptionsList from "../SubscriptionsList";
import StandardLayout from "components/Library/Layout/containers/StandardLayout";
import LatestStories from "../../../components/Library/LatestStories";

import { getSubscriptions } from "../../actions/subscriptions";

class Subscriptions extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.getSubscriptions({ subscription_type: "newsletter" });
  }

  render() {
    const { subscriptions } = this.props;
    const queryParams = parse(this.props.location.search.slice(1));
    if (!queryParams.page) {
      queryParams.page = "newsletters-page";
    }

    return (
      <>
        <SubscriptionHeader />
        <StandardLayout
          mainAriaLabel="Newsletters"
          main={
            <SubscriptionsList
              subscriptions={subscriptions}
              queryParams={queryParams}
            />
          }
          complementary={<LatestStories />}
        />
      </>
    );
  }
}

Subscriptions.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }),
};

const mapStateToProps = state => {
  return {
    subscriptions: state.subscriptions,
  };
};

export default connect(
  mapStateToProps,
  { getSubscriptions }
)(Subscriptions);
